import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { ResultsComponent, SearchComponent, SearchSkillsCategoriesComponent } from './components';
import { RouterModule } from '@angular/router';
import { LoaderModule, PipeModule } from '@app/shared';
import { PathResultComponent } from './components/results/components/path-result/path-result.component';
import { MissionResultComponent } from './components/results/components/mission-result/mission-result.component';
import { CourseResultComponent } from './components/results/components/course-result/course-result.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { RedirectDirective } from './directives/redirect.directive';
import { EnterKeyUpModule } from '@app/shared/accesibility/keyboard-shortcuts';
import { TermsResultsComponent } from './components/terms-results/terms-results.component';
import { ButtonSearchComponent, IconComponent } from '@app/tw-shared/components';
import { DataTestModule } from '@app/shared/directive/data-test';
import { ListDirective } from '@app/tw-shared/directives/list/list.directive';
import { ListItemDirective } from '@app/tw-shared/directives/list-item/list-item.directive';
import { ComboboxTypeaheadDirective, NavItemDirective } from '@app/tw-shared/directives';
import { SearchDirective } from './directives';

@NgModule({
    declarations: [
        SearchComponent,
        ResultsComponent,
        SearchSkillsCategoriesComponent,
        PathResultComponent,
        MissionResultComponent,
        CourseResultComponent,
        RedirectDirective,
        TermsResultsComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        RouterModule,
        LoaderModule,
        InlineSVGModule,
        PipeModule,
        EnterKeyUpModule,
        ButtonSearchComponent,
        IconComponent,
        DataTestModule,
        ComboboxTypeaheadDirective,
        ListDirective,
        ListItemDirective,
        SearchDirective,
        NavItemDirective,
    ],
    exports: [SearchComponent, ReactiveFormsModule, TermsResultsComponent],
})
export class SearchModule {}
